/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { DocLocationCard, SimpleCard } from '../Card';
import {
  HeadingDescSmall,
  HeadingDescVsmall,
  SectionHeadingSmall
} from '../Headings';
import { RankTag, SimpleTag } from '../tags';
import star from '../../assets/images/svg/star-small.svg';
import onlineIcon from '../../assets/images/svg/circle-green.svg';
import { UserContinueModal } from '../customModals';
import './doctorListingBox.css';

function DoctorListingBox(props) {
  const [modal, setModal] = useState('false');
  const {
    docImg,
    docImgBgColor,
    docName,
    speciality,
    education,
    rating,
    people,
    rank,
    color,
    rankText,
    years,
    waitTime,
    online,
    locations
  } = props;
  return (
    <div className="doctorListingBox">
      <SimpleCard>
        <Row>
          <Col md={6}>
            <div className="leftBox">
              <div className="cardDocInfo">
                <div>
                  <div
                    className="imgBox"
                    style={{ backgroundColor: docImgBgColor }}
                  >
                    <img src={docImg} alt="docImg" />
                  </div>
                  <div className="docRating">
                    <img src={star} alt="star" />
                    <HeadingDescVsmall text={rating} />
                    <HeadingDescVsmall text={`(${people})`} />
                  </div>
                </div>
                <div>
                  <div className="docInfo">
                    <SectionHeadingSmall text={docName} />
                    <HeadingDescSmall text={speciality} />
                    <HeadingDescSmall text={education} />
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="rightBox">
              {rankText && (
                <RankTag
                  bgColor={color}
                  icon={rank}
                  text={`${rankText} doctor`}
                />
              )}
              <div className="experianceContainer">
                <div>
                  <HeadingDescSmall text={<b>Experience:</b>} />
                  <HeadingDescSmall text={`${years} Years`} />
                </div>
                <div>|</div>
                <div>
                  <HeadingDescSmall text={<b>Wait Time: </b>} />
                  <HeadingDescSmall text={`Under ${waitTime} Min`} />
                </div>
              </div>
              {online ? (
                <SimpleTag text="Available now">
                  <img src={onlineIcon} alt="onlineIcon" />
                </SimpleTag>
              ) : (
                ''
              )}
            </div>
          </Col>
          <Col md={12}>
            <DocLocationCard locations={locations} />
            {/* <div className="locationContainer">{locations}</div> */}
          </Col>
        </Row>
      </SimpleCard>
      <UserContinueModal show={modal === 'm2'} close={() => setModal(false)} />
    </div>
  );
}

export default DoctorListingBox;
